<template>
  <div class="prize" >
    <router-link :to="advertisingInfo.href || ''">
      <img :src="advertisingInfo.img" />
    </router-link>
  </div>
</template>
<script>
export default {
  props: {
    advertisingInfo: {
      type: Object,
      default: Object
    }
  }
}
</script>
<style scoped>
.prize {
  margin: 0.1rem 0;
}
</style>
